import Vue from 'vue';
import VueTheMask, { mask } from 'vue-the-mask';
Vue.use(VueTheMask);
Vue.directive('mask', mask);